export const environment = {
    baseUrl:"https://iot-forkliftiot.azurewebsites.net/api/"
    // baseUrl:"https://forkliftiot.azurewebsites.net/api/"
}